<template>
  <div class="qmkey-explorer-view">
    
    <!-- LOADING -->
    <div class="overflow-hidden">
      <slot name="loading">
        <div v-if="loading">
          <v-progress-linear
            v-if="qunits && (qunits.length > 0)"
            indeterminate
            color="primary"
          />
          <v-progress-circular
            v-else
            indeterminate
            color="primary"
            class="mt-5 qmkey-progress-circular"
          />
        </div>
      </slot>
    </div>
    <div v-if="qunits && qunits.length">
      
  
      <!-- SORT SELECT -->
      <div class="qmkey-explorer-card-sort">
        <div class="align-self-center">
          <v-btn v-if="view_props.selectable && view_props.checkbox" icon :disabled="disabled" @click="select_all">
            <v-icon color="primary">
              {{select_icon}}
            </v-icon>
          </v-btn>
        </div>
        <div class="reduced-selector-block">
          <v-select
            v-if="select_cols && select_cols.length > 0"
            v-model="sort_by"
            :disabled="disabled || loading"
            :items="select_cols"
            outlined
            dense
            chips
            hide-no-data
            hide-details
            @input="change_sort"
          >
            <template v-slot:selection="data">
              <v-chip
                small
                color="primary"
                @click.stop="update_sort_desc"
                @mousedown.stop
                @mouseup.stop
                :disabled="disabled || loading"
              >
                
                <span>
                  {{ data.item.text }}
                  <v-icon :disabled="disabled">
                    {{ local_filters.get_filter_value('sort_desc') ? 'mdi-sort-descending' : 'mdi-sort-ascending' }}
                  </v-icon>
                </span>
              </v-chip>
            </template>
          </v-select>
        </div>
        <div class="align-self-center">
          <slot name='header_right_panel'>
          </slot>
        </div>
      </div>
      <!-- CARD LIST -->
      <v-list>
        <v-list-item
          v-for="(unit,i) in qunits.units"
          :key="unit.uid"
        >
          <Card
            :unit="unit"
            @click="qunit_clicked(unit)"
            @action-click="select_qunit(unit.uid)"
            @navigate_to="navigate_to(unit)"
            @update="(filters) => update_row(props.item, filters)"
            @update-qunit="update_qunit"
            @update-qunit-at="update_qunit"
            :actions="view_props.actions"
            :disabled="disabled"
            :checkbox="view_props.checkbox"
            :selectable="view_props.selectable"
            :action_list="view_props.action_list"
            :navigate="view_props.navigate"
            :isSelected="object_selected[unit.uid]"
            :is_mobile="is_mobile"
          />
        </v-list-item>
      </v-list>
      
      <slot name="footer">
          <QPagination
              :max_visible_buttons="3"
              :current_page="local_filters.get_filter_value('page')"
              :total_units="qunits.count"
              allow_change_items_per_page
              :items_per_page="local_filters.get_filter_value('units_per_page')"
              :units_length="qunits.length"
              :disabled="disabled"
              @page_changed="change_page"
              @items_per_page_changed="change_units_per_page"
          />
      </slot>
    </div>
    <!-- NO DATA -->
    <slot name="no-data">
    <div
      v-if="!loading && !(qunits && (qunits.length > 0))"
      class="mt-5"
    >
      {{ $vuetify.lang.translator('explorer.no_data') }}
    </div>
    </slot>
  </div>
</template>
  
<style lang="scss">
  @import '@/sass/explorer.scss';
  .qmkey-explorer-card-sort{
    padding-top: 0.5em;
    background-color: white;
    display: flex;
    justify-content: space-evenly !important;
  }
  .reduced-selector-block {
    min-width: 50%;
    max-width: 100%;
  }
</style>
    
    
<script>
  import QUnit from '@/qunit/QUnit';
  import { QUnitField } from '@/qunit/QFields';
  import QUnitCollection from '@/qunit/QUnitCollection';
  import Field from '@/components/qfields/Field';
  import Actions from '@/components/explorer/actions/Actions';
  import { downloadFile } from '@/utils/browserfiles';
  import { mapState, mapGetters } from 'vuex';
  import QPagination from '@/components/QPagination'
  import Card from '@/components/explorer/Card'
  import { QFilters, get_qfilter } from '@/qunit/filters';
   
  function true_indexes(vec) {
    // vec → [false, false, true]
    // res → [index]
    const res = [];
    for (let i = 0; i < vec.length; i++) {
      if (vec[i]) {
        res.push(i);
      }
    }
    return res;
  }
  export default {
    name: 'ExplorerCardList',
    
    components: {
      Field,
      Actions,
      QPagination,
      Card,
    },
    
    props: {
      qunits: QUnitCollection,
      filters: {type: QFilters, default: () => new QFilters()},
      loading: {
        type: Boolean,
        default: false,
      },
      already_selected: {default: () => ([])},
      view_props: {default: (()=> ({})) },
      disabled: Boolean,
    },
    
    data: () => ({
      sort_by: 'current_workflow_limit',
      sort_desc: false,
      local_filters: new QFilters(),
      header_col: ['reference', 'title'],

      all_selected: false,
      object_selected: {},
    }),
    
    computed: {
      ...mapGetters(['sitePath', 'user']),
      ...mapState(['is_mobile',]),
  
      sort_icon() {
        return this.unitsSortDesc ? 'mdi-sort-descending' : 'mdi-sort-ascending';
      },

      columns() {
        return this.qunits.columns.filter(
          col => (this.view_props.actions || col.value != 'action' || col.value != 'data-table-expand')
        );
      },
      select_cols() {
        return this.columns.filter(col => (col.value != 'action' && col.value != 'data-table-expand' && col.sortable || col.sortable == undefined))
      },
      aaa() {
        return Object.values(this.object_selected)
      },
      select_icon() {
        const object_values = this.object_selected;
        const selected_values = Object.values(object_values)
        if (this.all_selected) {
          return 'mdi-checkbox-marked-outline';
        } else {
          return selected_values.indexOf(true) >= 0 ? 'mdi-minus-box-outline' : 'mdi-checkbox-blank-outline';
        }
      },
  
    },
    
    mounted() {
      this.setup();
      this.pull_filters();
    },
  
    methods: {
      change_sort(input){
        this.sort_by = input;
      },
      setup() {
        if (this.units) {
          this.select_reset();
        }

        if (this.already_selected && this.qunits) {
          for (let uid of this.already_selected) {
            if (uid) {
              this.select_set(uid);
            }
          }
          this.all_selected = this.already_selected.length == this.qunits.count;
        }
      },
  
      select_reset() {
        this.object_selected = {};
      },
  
      select_set(uid) {
        if (!this.view_props.multiselect) {
          this.select_reset();
        }
        this.object_selected = {...this.object_selected,[uid]: !this.object_selected[uid]};
        this.$emit('update_selection',Object.entries(this.object_selected).filter(([_,value]) => !!value).map(([key,_]) => key));
      },
  
      select_qunit(uid) {
        if (uid) {
          this.select_set(uid);
        }
      },

      select_all() {
        this.all_selected = !this.all_selected;

        this.$emit('select_all',this.all_selected)
      },
  
      pull_filters() {
        if (this.qunits) {
          this.select_qunit(this.filters.get_filter_value('pk'));
        }
    
        this.local_filters = this.filters.copy();
    
        this.sort_by = this.filters.get_filter_value('sort_by');
        this.sort_desc = this.filters.get_filter_value('sort_desc');
      },
  
      launch_update(temporary_filters) {
        let filters = this.local_filters;
        this.$emit('update_filters', filters);
      },
    
      update_row(unit, filters) {
        this.local_filters = this.local_filters.merge(filters);
        this.select_qunit(unit.uid);
        this.$emit('update', this.local_filters);
      },
  
      update_qunit(new_qunit) {
        this.select_qunit(new_qunit.uid);
        this.$emit('update-qunit', new_qunit);
      },
    
      update_page_count(units_per_page) {
        this.local_filters.set_filter(get_qfilter('units_per_page', units_per_page));
        this.launch_update();
      },
    
      update_after_transition(qunit) {
        if (qunit) {
          this.pull_inline_state(qunit.uid);
          this.select_qunit(qunit.uid);
        }
        this.$emit('update-qunit', qunit);
      },
    
      qunit_clicked(qunit) {
        this.select_qunit(qunit.uid);
        this.$emit('click', qunit);
      },
    
      navigate_to(unit) {
        this.$emit('navigate_to',unit);
      },
  
      update_sort_by(key) {
        if (key != this.local_filters.get_filter_value('sort_by')) {
          //this.sort_by = key;
          this.local_filters.set_filter(get_qfilter('sort_by',key));
          this.launch_update();
        }
      },
      update_sort_desc() {
        if (this.local_filters.get_filter_value('sort_desc') == this.sort_desc) {
          this.sort_desc = !this.sort_desc;
          this.local_filters.set_filter(get_qfilter('sort_desc',this.sort_desc));
          this.launch_update();
        } else {
          this.sort_desc = this.local_filters.get_filter_value('sort_desc');
        }
      },
    
      change_page(pnum) {
        this.local_filters.set_filter(get_qfilter('page',pnum),true);
        this.launch_update();
      },
    
      change_units_per_page(units) {
        this.local_filters.set_filter(get_qfilter('units_per_page',units));
        this.local_filters.set_filter(get_qfilter('page',1),true);
        this.launch_update();
      },
    
      export_state() {
        // Returns current table state
        return {
          selected: this.object_selected, 
        };
      },
  
      import_state(state) {
        // Import an state exported by export_state()
        function uid_to_trues(qunits, uids) {
          // uids → ['UID1', 'UID2']
          // Returns → [false, false, true]
          const res = new Array(qunits.length).fill(false);
          for (const uid of uids) {
            const pos = qunits.indexOf(uid);
            if (pos >= 0) {
              res[pos] = true;
            }
          }
          return res
        }
    
        // selected
        this.object_selected = state.object_selected || {};
    
      },
  
    },
    watch: {
      sort_by(sort){
        this.update_sort_by(sort);
      },
      filters() {
        this.pull_filters();
      },
      already_selected() {
        this.object_selected = Object.fromEntries(this.already_selected.map(it => ([it,true])));
        this.all_selected = this.already_selected.length == ((this.qunits || {})).count;
      },
  
      qunits(value) {
        // const state = this.export_state(); // To keep the state on qunits change.
        //                                       do we needed? I don't know yet ‾\_(ツ)_/‾
        //this.setup();

        if (this.qunits) {
          const page = this.filters.get_filter_value('page') || this.qunits.page || 1;
          this.local_filters.set_filter(get_qfilter('page',page),true);
          let sort_by = this.local_filters.get_filter_value('sort_by')
          if (!sort_by) {
            sort_by = this.qunits.columns.findIndex(it => it.value == "current_workflow_limit") > 0 
                                  ? "current_workflow_limit" 
                                  : (this.qunits.columns[0] || {}).name
            this.local_filters.set_filter(get_qfilter('sort_by', sort_by))
          }
        }
        // this.import_state(state); // To keep the state on qunits change
      },
    },
  }
</script>
    
